<div *ngFor="let subtheme of themes"><h2>{{subtheme.name}}</h2><p>{{subtheme.description.name}}</p></div>